import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

import SimpleLightbox from "simplelightbox";
import 'simplelightbox/dist/simple-lightbox.css';

import '../css/blocks/slider.css'
const swipers = document.querySelectorAll('.slider .swiper');
if (swipers) {
    //console.log(swipers.length)

    swipers.forEach((element) => {
        var thumbs = parseInt(element.dataset.thumbs)
        var id = element.id.replace('swiper-', '')
        var thumbsid = "#thumbs-" + id;
        var thumbSwiper = new Swiper(thumbsid, {
            loop: true,
            spaceBetween: 10,
            slidesPerView: thumbs,
            freeMode: true,
            watchSlidesProgress: true,
        })
        var swiperid = "#swiper-" + id;
        new Swiper(swiperid, {
            modules: [Navigation, Thumbs],
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumbSwiper,
            }
           
        });
        new SimpleLightbox(swiperid + ' a.swiper-slide ', { /* options */ });
    })
}